import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { openLoginModal } from 'store/actions/login.actions';
import { UserType } from 'types/user.types';

import Loader from '../../../Loader/Loader';
import HeaderItem from '../HeaderItem';
import HeaderNotifications from '../HeaderNotifications/HeaderNotifications';

type Props = {
  user: UserType;
  isLoginLoading: boolean;
};

const mapStateToProps = ({ userData }) => ({
  user: userData && userData.user,
  isLoginLoading: userData?.isLoading,
});

const HeaderLogin = (props: Props) => {
  const { user, isLoginLoading } = props;

  const { t } = useTranslation();
  const isLoggedIn = user?.isLoggedIn;

  return (
    <HeaderItem className="logged-status-box">
      {isLoginLoading ? (
        <Loader my={0} size={30} justify="flex-end" className="loader-wrapper" />
      ) : isLoggedIn ? (
        <HeaderNotifications />
      ) : (
        <Button color="primary" variant="outlined" className="login-btn" onClick={() => openLoginModal(true)}>
          {t('common.log-in')}
        </Button>
      )}
    </HeaderItem>
  );
};

export default connect(mapStateToProps)(HeaderLogin);
